<div class="view-item">
  <div class="card line-item-card">
    <div class="card-header">
      <div>
        {{ "ENTRY_SUMMARY.LINE_ITEM" | translate }} #{{ index }}
        <b *ngIf="fieldsConfig?.htsNumber?.hasValue">
          {{ fieldsConfig?.htsNumber?.value | mask : HTS_MASK }}
        </b>
        <span *ngIf="fieldsConfig?.htsNumber?.hasError" class="text-error">
          {{ fieldsConfig.htsNumber.firstError | translate }}
        </span>
      </div>
      <div class="isf-actions">
        <div class="arrow-item">
          <icon-toggle-open-close [open]="open" (click)="toggleOpen()"></icon-toggle-open-close>
        </div>
        <span
          *ngIf="isSelectMode"
          class="chk"
          [ngClass]="{ 'is-checked': isSelected }"
          role="checkbox"
          tabindex="0"
          [attr.aria-checked]="isSelected"
          [attr.aria-label]="('LABELS.SELECT_ROW' | translate) + ' ' + index"
          (click)="selectToggle.emit()"
          (keydown.enter)="selectToggle.emit()"
          (keydown.space)="$event.preventDefault(); selectToggle.emit()"
        >
          <svg class="chk-icon tick" width="12" height="12" viewBox="0 0 24 24" fill="none" *ngIf="isSelected">
            <path d="M5 12.5l4.2 4.2L19 7" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </span>
        <dropdown-action
          *ngIf="!isSelectMode && (isCanView || isCanEdit)"
          [iconColor]="iconColor"
          [menuMode]="menuMode"
          [id]="'es-invoice-summary-details-line-item-' + index"
          className=""
        >
          <button *ngIf="isCanView || isCanEdit" dropdown-item class="dropdown-item" (click)="editItem()">
            {{ (isCanEdit ? "BUTTON.EDIT" : "BUTTON.VIEW") | translate }}
          </button>
          <button dropdown-item *ngIf="isCanEdit" class="dropdown-item" (click)="duplicateItem()">
            {{ "BUTTON.DUPLICATE" | translate }}
          </button>
          <button dropdown-item *ngIf="isCanEdit" class="dropdown-item" (click)="openModal()">{{ "BUTTON.DELETE" | translate }}</button>
        </dropdown-action>
      </div>
    </div>
    <div class="card-body" [ngClass]="{ 'pt-0': (!item || !item.description) && !open }">
      <div *ngIf="item && item.description" class="row preview">
        <div class="col-12 description">{{ item.description }}</div>
      </div>
      <div class="body">
        <div *ngIf="open">
          <div class="row line" *ngIf="fieldsConfig?.countryOfOrigin?.shown">
            <div class="col label">{{ "FORM_LABEL.COUNTRY_OF_ORIGIN" | translate }}</div>
            <div
              class="col flex-grow-0 flex-shrink-0 value text-right text-nowrap"
              [ngClass]="{ error: fieldsConfig?.countryOfOrigin?.hasError }"
            >
              {{
                fieldsConfig?.countryOfOrigin?.hasError
                  ? (fieldsConfig.countryOfOrigin.firstError | translate)
                  : countryOfOrigin
                  ? countryOfOrigin.code + " " + countryOfOrigin.description
                  : ""
              }}
            </div>
          </div>

          <div class="row line" *ngIf="fieldsConfig?.stateOfOrigin?.shown">
            <div class="col label">{{ "FORM_LABEL.STATE_OF_ORIGIN" | translate }}</div>
            <div
              class="col flex-grow-0 flex-shrink-0 value text-right text-nowrap"
              [ngClass]="{ error: fieldsConfig?.stateOfOrigin?.hasError }"
            >
              {{
                fieldsConfig?.stateOfOrigin?.hasError
                  ? (fieldsConfig.stateOfOrigin.firstError | translate)
                  : stateOfOrigin
                  ? stateOfOrigin.code + " " + stateOfOrigin.description
                  : ""
              }}
            </div>
          </div>

          <div class="row line" *ngIf="fieldsConfig?.countryOfExport?.shown">
            <div class="col label">{{ "LABELS.COUNTRY_OF_EXPORT" | translate }}</div>
            <div
              class="col flex-grow-0 flex-shrink-0 value text-right text-nowrap"
              [ngClass]="{ error: fieldsConfig?.countryOfExport?.hasError }"
            >
              {{
                fieldsConfig?.countryOfExport?.hasError
                  ? (fieldsConfig.countryOfExport.firstError | translate)
                  : countryOfExport
                  ? countryOfExport.code + " " + countryOfExport.description
                  : ""
              }}
            </div>
          </div>

          <div class="row line" *ngIf="fieldsConfig?.quantity1?.shown || fieldsConfig?.unitOfMeasure1?.shown">
            <div class="col label">{{ "LABELS.QUANTITY" | translate }}</div>
            <div
              class="col flex-grow-0 flex-shrink-0 value text-right text-nowrap"
              [ngClass]="{
                error: fieldsConfig?.quantity1?.hasError || fieldsConfig?.unitOfMeasure1?.hasError
              }"
            >
              <ng-template [ngIf]="fieldsConfig?.quantity1?.hasError || fieldsConfig?.unitOfMeasure1?.hasError">
                {{ fieldsConfig.quantity1.firstError || fieldsConfig.unitOfMeasure1.firstError | translate }}
              </ng-template>

              <ng-template [ngIf]="!fieldsConfig?.quantity1?.hasError && !fieldsConfig?.unitOfMeasure1?.hasError">
                {{ fieldsConfig?.quantity1?.value }} {{ fieldsConfig?.unitOfMeasure1?.value }}
              </ng-template>
            </div>
          </div>

          <div class="row line" *ngIf="fieldsConfig?.quantity2?.shown || fieldsConfig?.unitOfMeasure2?.shown">
            <div class="col label">{{ "LABELS.QUANTITY" | translate }}</div>
            <div
              class="col flex-grow-0 flex-shrink-0 value text-right text-nowrap"
              [ngClass]="{ error: fieldsConfig?.quantity2?.hasError || fieldsConfig?.unitOfMeasure2?.hasError }"
            >
              <ng-template [ngIf]="fieldsConfig?.quantity2?.hasError || fieldsConfig?.unitOfMeasure2?.hasError">
                {{ fieldsConfig?.quantity2?.firstError || fieldsConfig?.unitOfMeasure2?.firstError | translate }}
              </ng-template>

              <ng-template [ngIf]="!fieldsConfig?.quantity2?.hasError && !fieldsConfig?.unitOfMeasure2?.hasError">
                {{ fieldsConfig?.quantity2?.value }} {{ fieldsConfig?.unitOfMeasure2?.value }}
              </ng-template>
            </div>
          </div>

          <div class="row line" *ngIf="fieldsConfig?.quantity3?.shown || fieldsConfig?.unitOfMeasure3?.shown">
            <div class="col label">{{ "LABELS.QUANTITY" | translate }}</div>
            <div
              class="col flex-grow-0 flex-shrink-0 value text-right text-nowrap"
              [ngClass]="{ error: fieldsConfig?.quantity3?.hasError || fieldsConfig?.unitOfMeasure3?.hasError }"
            >
              <ng-template [ngIf]="fieldsConfig?.quantity3?.hasError || fieldsConfig?.unitOfMeasure3?.hasError">
                {{ fieldsConfig.quantity2?.firstError || fieldsConfig?.unitOfMeasure2?.firstError | translate }}
              </ng-template>

              <ng-template [ngIf]="!fieldsConfig?.quantity3?.hasError && !fieldsConfig?.unitOfMeasure3?.hasError">
                {{ fieldsConfig?.quantity3?.value }} {{ fieldsConfig?.unitOfMeasure3?.value }}
              </ng-template>
            </div>
          </div>

          <div class="row line" *ngIf="fieldsConfig?.grossWeight?.shown">
            <div class="col label">{{ "LABELS.GROSS_WEIGHT" | translate }}</div>
            <div
              class="col flex-grow-0 flex-shrink-0 value text-right text-nowrap"
              [ngClass]="{ error: fieldsConfig?.grossWeight?.hasError }"
            >
              {{
                fieldsConfig?.grossWeight?.hasError
                  ? (fieldsConfig?.grossWeight?.firstError | translate)
                  : fieldsConfig?.grossWeight?.value + " " + WEIGHT_UNIT_KG
              }}
            </div>
          </div>

          <div class="row line" *ngIf="fieldsConfig?.specialChapterHtsNumber?.shown">
            <div class="col label">{{ "FORM_LABEL.SPECIAL_CHAPTER_HTS_CODE" | translate }}</div>
            <div class="col flex-grow-0 flex-shrink-0 value text-right text-nowrap">
              <div *ngIf="fieldsConfig?.specialChapterHtsNumber?.hasValue">
                {{ fieldsConfig?.specialChapterHtsNumber?.value | mask : HTS_MASK }}
              </div>
              <div *ngIf="fieldsConfig?.specialChapterHtsNumber?.hasError" class="value error">
                {{ fieldsConfig?.specialChapterHtsNumber?.firstError | translate }}
              </div>
            </div>
          </div>

          <div class="row line" *ngIf="item.hasNaftaNetCostIndicator">
            <div class="col label">{{ "FORM_LABEL.HAVE_TRADE_CERTIFICATE" | translate }}</div>
          </div>
        </div>
        <div class="row line line-top" [ngClass]="{ 'border-top-0': (!item || !item.description) && !open }">
          <div class="col label">{{ "FORM_LABEL.ENTERED_VALUE" | translate }}</div>
          <div class="col flex-grow-0 flex-shrink-0 value text-right text-nowrap" [ngClass]="{ error: fieldsConfig?.value?.hasError }">
            <span *ngIf="fieldsConfig?.value?.hasValue && currencyCode !== DEFAULT_CURRENCY_CODE" class="text-gray">
              ({{ fieldsConfig?.value?.value | currency : currencyCode : "" : "1.2-2" }} {{ currencyCode }})
            </span>
            <span *ngIf="fieldsConfig?.value?.hasValue" class="bold">
              {{ fieldsConfig?.value?.value * currencyRate | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2" }}
            </span>
            <span *ngIf="fieldsConfig?.value?.hasError">
              {{ fieldsConfig?.value?.firstError | translate }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<custom-modal [header]="'LABELS.DELETE_ITEM'" [type]="'error'" [(open)]="isModalOpen">
  <div>{{ "DELETE_ITEM_TEXT" | translate }}</div>
  <button footer-action type="button" class="btn btn-secondary" (click)="onDecline()">
    {{ "BUTTON.NO_KEEP_IT" | translate | uppercase }}
  </button>
  <button footer-action type="button" class="btn btn-primary" (click)="onDelete()">
    {{ "BUTTON.YES_DELETE" | translate | uppercase }}
  </button>
</custom-modal>
